import ScratchPadContainer from './container';
import ScratchPad from './ScratchPad';

export { ScratchPad };
export default ScratchPadContainer;
